// extracted by mini-css-extract-plugin
module.exports = {"Empty":"Empty--3I72e","Text":"Text--1oy8a"};